import React from 'react'
import iconNames from 'theme/icons'
import { features } from 'helpers/constants'
import {t} from "helpers/language"

export const skill = {
  key: "RAISE_QUOTE",
  group: 'quoting',
  label: t("Raise a quote"),
  desc: t("Raise a new quote for the customer you're currently dealing with"),
  feature: features.QUOTING_LICENCE,
  steps: [
    {
      target: '.header-addButton',
      content: <div>To raise a new quote <i>Tap The Add Button</i>. You can use this button at any time to add a new contact, activity or quote.</div>,
    },
    {
      target: '.addMenu-addQuote',
      content: <div><i>Tap Add Quote</i> to raise a new quote</div>,
      placement: 'left',
      awaitElement: {interval: 100},
    },
    {
      // Inline tooltip in quote dialog
      dummy: true,
      addQuoteDialog: true, // sets the page number on the contact dialog
    },
    {
      title: "Quote Raised",
      titleIcon: iconNames.tick,
      titleIconColor: "green",
      content: (
        <div>
          {"Awesome work, you've raised your quote!"}<br/>
          <br/>
          {"Continue to learn more about populating the quote and sending it to the customer"}
        </div>
      ),
      actions: [
        {
          label: "Learn More Skills",
          flat: true,
          type: 'skills',
        },
        {
          label: "Yes Please, Let's Populate My Quote",
          primary: true,
          type: "skill",
          skill: "POPULATE_QUOTE",
          page: 1,
        },
      ],
    },
  ],
}

export default skill
